import axios from 'axios'
import { getAuth } from '@misc'

const API = process.env.REACT_APP_API_URL
const FLIGHT = process.env.REACT_APP_FLIGHT_ENDPOINT

const admin = () => ({ 'Content-Type': 'application/json', ...getAuth() })

export async function getUsers() {
    const { data } = await axios({ url: `${API}/flight/users`, method: 'GET', headers: admin() })
    return Array.isArray(data) ? data : data.users || []
}

export async function getUserSuppliers(userId) {
    const { data } = await axios({
        url: `${API}/flight/users/${userId}/suppliers`,
        method: 'GET',
        headers: admin()
    })
    const list = data.suppliers || data || []
    return list.filter(s => !s.inactive)
}

export async function genToken(id, email) {
    const { data } = await axios({
        url: `${API}/flight/generate-token`,
        method: 'POST',
        headers: admin(),
        data: { id: `${id}`, email }
    })
    return data.data ? data.data.auth_token : data.auth_token
}

export async function searchAirports(q) {
    const { data } = await axios({
        url: `${API}/flight/airports`,
        method: 'GET',
        params: { q, limit: 20 },
        headers: admin()
    })
    return data.airports || []
}

// Fire /get/flights and re-POST the same body until progress >= 1 (poll model).
export async function runSearch({ headers, body, onTick, maxWaitMs = 90000 }) {
    const started = Date.now()
    let res
    let attempts = 0
    /* eslint-disable no-await-in-loop */
    do {
        attempts += 1
        const resp = await axios({
            url: `${FLIGHT}/get/flights`,
            method: 'POST',
            headers,
            data: body
        })
        res = resp.data
        if (onTick) onTick({ progress: res.progress, attempts, res })
        if (res.progress >= 1) break
        await new Promise(r => setTimeout(r, 2500))
    } while (Date.now() - started < maxWaitMs)
    /* eslint-enable no-await-in-loop */
    return { ...res, attempts }
}

// trace-id → runnable flight search curl → parsed payload
export async function traceToPayload(raw) {
    const m = String(raw).match(/[a-f0-9]{32}/i)
    if (!m) throw new Error('No trace-id (32-hex) found in the input')
    const traceId = m[0]
    const { data } = await axios({
        url: `${API}/flight/trace-curl`,
        method: 'GET',
        params: { trace_id: traceId },
        headers: admin()
    })
    const curl = data.curl || ''
    const dm = curl.match(/--data(?:-raw)?\s+'([\s\S]*)'\s*$/)
    if (!dm) throw new Error('Could not parse payload from curl')
    const payload = JSON.parse(dm[1])
    const emailMatch = curl.match(/x-key:\s*([^'\s]+)/)
    return { traceId, payload, email: emailMatch ? emailMatch[1] : null, curl }
}

export const endpoints = { API, FLIGHT }
